import { IForestReduction } from "../interfaces/IEstate";

export const initialForestReduction: IForestReduction = {
    sellerTotalForestReduction: null
}